<template>
  <div
    class="cf-node-properties__panel"
    :class="{
      'cf-node-properties__panel--open': showContent,
      'cf-node-properties__panel--error': !route.isValid
    }"
  >
    <div
      class="cf-node-properties__panel-heading"
      @click="showContent = !showContent"
    >
      <div>
        <span
          v-if="openOptions"
          class="p-r-5"
        >
          <i
            class="fa fa-angle-right"
            :class="{ 'fa-rotate-90': showContent }"
            aria-hidden="true"
          />
        </span>
        <i
          v-if="hasFilter"
          class="fa fa-filter p-r-5"
          :class="filterClass"
        />
        <span class="m-r-10"><strong
          v-if="route.weight"
          class="m-r-5"
        >{{ weightInfo }}</strong> {{ routeName }}</span>
        <span>
          <i
            v-if="targetNode.nodeOptions.icon"
            :class="targetNode.nodeOptions.icon"
            class="m-r-5"
            aria-hidden="true"
          />
          {{ displayName }}
        </span>
        <button
          v-if="addRoutes"
          class="btn btn-function m-l-10"
          @click.stop.prevent="addNodeToRoute"
        >
          <i class="fa fa-plus" />
        </button>
      </div>
      <SortableDragButton v-if="sortable" />
    </div>

    <collapse
      v-if="openOptions"
      v-model="showContent"
    >
      <div
        ref="panelBody"
        tabindex="-1"
        class="cf-node-properties__panel-body"
      >
        <slot />
      </div>
    </collapse>
  </div>
</template>

<script>
import messages from '../../../../locales';
import SortableDragButton from '@/core/components/DraggableTable/components/SortableDragButton.vue';

export default {
  name: 'RoutePanel',
  components: { SortableDragButton },
  props: ['route', 'index', 'openOptions', 'addRoutes', 'hasFilter', 'focusElement', 'customHeader', 'weightSum', 'sortable'],
  data() {
    return {
      showContent: !!this.focusElement,
      parsedCriteria: [],
    };
  },
  computed: {
    targetNode() {
      if (this.route.targetNode) {
        return this.route.targetNode;
      } else {
        return {
          nodeOptions: {},
          displayName: this.route.displayName,
          name: this.route.name,
        };
      }
    },
    filterClass() {
      if (this.route.isValid !== undefined && !this.route.isValid) {
        return 'filter-error';
      }
      return this.route.criteria && this.route.criteria.length > 0 ? 'filter-active' : 'text-muted';
    },
    weightInfo() {
      if (this.weightSum) {
        const percent = (this.route.weight / this.weightSum) * 100;
        return  ` ${parseFloat(percent.toFixed(2))}%`;
      }
      return '';
    },
    routeName() {
      const name = this.route.name;
      return name + ' : ';
    },
    displayName() {
      return  this.targetNode.stepName || this.targetNode.displayName;
    }
  },
  mounted() {
    if (this.focusElement) {
      setTimeout(() => this.$refs.panelBody.focus(), 300);
      
    }
  },
  methods: {
    addNodeToRoute(event) {
      this.$emit('addNodeToRoute', event);
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>